module.exports = __webpack_public_path__ + "img/location.ac69a876.svg";